<template>
  <v-row>
    <v-col cols="1">
      <v-checkbox
        v-model="documentData.selected"
        class="mt-3 ml-4"
        :disabled="disabled"
      />
    </v-col>
    <v-col cols="5">
      <v-select
        v-model="documentData.type"
        :disabled="isDisabled"
        :items="documentTypes"
        label="Document Type"
        outlined
        :error-messages="getErrorMessages($v.documentData.type)"
        @input="_ => triggerValidations()"
      />
    </v-col>
    <v-col cols="5">
      <v-text-field
        v-model="documentData.name"
        :disabled="isDisabled"
        label="Name"
        outlined
        :suffix="`.${documentData.extension}`"
        :error-messages="getErrorMessages($v.documentData.name)"
        @input="_ => triggerValidations()"
        @change="_ => onDocumentNameChanged()"
      />
    </v-col>
    <v-col
      class="text-center"
      cols="1"
    >
      <v-btn
        block
        class="mt-2"
        depressed
        :disabled="disabled"
        @click="_ => openDocument()"
      >
        <v-icon>
          mdi-eye
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { requiredIf } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

export default {
  name: 'LegalCaseEditorImportPartyEditDocument',

  model: {
    prop: 'document',
    event: 'change',
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    document: {
      type: Object,
      required: true,
    },

    documentTypes: {
      type: Array,
      required: true,
    },
  },

  setup () {
    return {
      $v: useVuelidate(),
    }
  },

  computed: {
    documentData () {
      return this.document
    },

    isDisabled () {
      return this.disabled || !this.documentData.selected
    },
  },

  validations () {
    return {
      documentData: {
        name: { required: requiredIf(!this.isDisabled) },
        type: { required: requiredIf(!this.isDisabled) },
      },
    }
  },

  methods: {
    getErrorMessages (validator) {
      return validator?.$errors?.map(e => e.$message)
    },

    onDocumentNameChanged () {
      this.$emit('document-name-changed', this.documentData.name)
    },

    openDocument () {
      this.$emit('preview-document', this.documentData.external_id)
    },

    triggerValidations () {
      this.$v.$validate()
    },
  },
}
</script>
